import {
  StatusTransitionRequirement,
  Step,
  StepAssociation,
  TransitionableEntity,
} from './status-transition-requirement';
import { DateTime } from 'luxon';

export namespace StatusTransitionRequirementParsers {
  export type StatusTransitionRequirementJson = {
    id: string;
    fromStatus: string;
    toStatus: string;
    step: Step;
    entity: string;
    createdAt: DateTime;
    createdBy: number;
  };

  export function toStatusTransitionRequirement(input: StatusTransitionRequirementJson): StatusTransitionRequirement {
    return {
      id: input.id,
      fromStatus: input.fromStatus,
      toStatus: input.toStatus,
      step: input.step,
      entity: input.entity as TransitionableEntity,
      createdAt: input.createdAt,
      createdBy: input.createdBy,
    };
  }

  export type StepAssociationJson = {
    entity: string;
    fromStatuses: string[];
  };

  export type StepJson = {
    id: string;
    name: string;
    label: string;
    metadata: { associated: StepAssociationJson[] };
  };

  export function toStepAssociation(input: StepAssociationJson): StepAssociation {
    return {
      entity: input.entity as TransitionableEntity,
      fromStatuses: input.fromStatuses,
    };
  }

  export function toStep(input: StepJson): Step {
    return {
      id: input.id,
      name: input.name,
      label: input.label,
      metadata: { associated: input.metadata.associated.map(toStepAssociation) },
    };
  }
}
